
import Input from "../Input";
import Output from "../Output";

import switchImage from "../../assets/switch.png";
import { Helmet } from 'react-helmet-async';
import { Link } from "react-router-dom";

import bolgar from "../../assets/bolgar.png"
import magyar from "../../assets/magyar.png"
import arrow from "../../assets/arrow.png"



function MagyarBolgar({ handleText, output, handleTarget, handleSource, langs, handleSwap, handleTranslate, text }) {


    return (

        <>
            <Helmet>
                <title>Magyar bolgár fordító</title>
                <meta name='description' content="Ingyenes magyar bolgár fordító szavakra, kifejezésekre, mondatokra. Akár teljes szöveg fordítása is." />
                <meta title="Magyar bolgár fordító" />
                <link rel="canonical" href="https://online-fordito.hu/magyar-bolgar-fordito" />
            </Helmet>
            <h1>Magyar bolgár fordító</h1>
            <div className="wrapper">
                <div>
                    <Input handleText={handleText} handleSource={handleSource} langs={langs} text={text}></Input>
                    <button className="transbutton" onClick={handleTranslate}>Fordítás</button>
                </div>

                <button className="switch" onClick={handleSwap}><img src={switchImage}></img></button>


                <Output output={output} handleTarget={handleTarget} langs={langs} />

            </div>

            <section>

                <div className="sectionhead">
                    <h2>A magyar és bolgár nyelv </h2>
                    <img src={magyar} alt="Magyar zászló"></img>
                    <img src={bolgar} alt="lengyel zászló"></img>

                </div>


                <p>Bár mindkét nyelv a tágabb uráli nyelvcsaládhoz tartozik, nem állnak szoros rokonságban. A bolgár délszláv, míg a magyar finnugor nyelv. Íme néhány fő hasonlóság és különbség a bolgár és a magyar között:</p>

                <h3>Hasonlóságok</h3>

                <ul>
                    <li><b>Nyelvtani nem</b>: A bolgár és a magyar nyelvnek is van nyelvtani neme. A bolgár nyelvnek három neme van (férfi, női és semleges), míg a magyarnak két neme (közönséges és semleges).</li>
                    <li><b>Esetrendszer</b>: Mindkét nyelvnek van esetrendszere, ami azt jelenti, hogy a főnevek, névmások és melléknevek alakjukat a mondatban betöltött nyelvtani funkciójuk szerint változtatják.</li>
                    <li><b>Magánhangzó-harmónia</b>: A magyarban van egy magánhangzó-harmónia nevű jelenség, ahol a szavak magánhangzóit front- vagy backness alapján hatnak egymásra. A bolgár is bizonyos fokú magánhangzó-harmóniát mutat, de kisebb mértékben.</li>
                </ul>

                <h3>Különbségek</h3>

                <ul>

                    <li><b>Nyelvcsalád</b>: Mint korábban említettük, a bolgár egy délszláv nyelv, amely az indoeurópai nyelvcsaládhoz tartozik. A magyar viszont egy finnugor nyelv, amely az uráli nyelvcsalád része.</li>
                    <li><b>Szókincs</b>: Különböző nyelvcsaládjaik miatt a bolgár és a magyar nyelvnek külön szókincse van. A bolgár nyelvnek számos kölcsönszója van más szláv nyelvekből, valamint törökből, görögből és más forrásokból. A magyar finnugor nyelvként egyedülálló szókinccsel rendelkezik, amely nem kapcsolódik szorosan más európai nyelvekhez.</li>
                    <li><b>Mondatszerkezet</b>: A bolgár az indoeurópai nyelvcsaládban általánosan elterjedt SVO (Alany-Ige-Tárgy) mondatszerkezetet követi. A magyar nyelvnek azonban van Alany-Tárgy-Ige (SOV) mondatszerkezete, ami eltér az európai nyelvekre jellemző szórendtől.</li>
                    <li><b>Kiejtés</b>: A bolgár és a magyar nyelv hangrendszere eltérő. A magyarnak viszonylag egyszerű hangrendszere van, következetes kiejtési szabályokkal, míg a bolgárnak bonyolultabb hangrendszere van, néhány szabálytalansággal.</li>

                </ul>

                <div className="sectionbottom">
                    <Link to="/bolgar-magyar-fordito">Bolgár magyar fordító</Link>
                    <img src={bolgar} alt="bolgár zászló"></img>
                    <img src={arrow} alt=">"></img>
                    <img src={magyar} alt="magyar zászló"></img>
                </div>
            </section>
        </>

    )
}

export default MagyarBolgar;